<script>
import FormMixin from "@/modules/fptai/mixins/FormMixin";
import {mapState} from "vuex";

export default {
    name: "BaseConfig",
    mixins: [FormMixin],
    data() {
        return {
            itemList: [],
            emptyItem: {},
            loadFn: null,
            saveFn: null,
            updateFn: null,
            deleteFn: null,
            mapOldItem: {}
        }
    },
    computed: {
        ...mapState({
            campaign: state => state.campaign.campaign
        }),
    },
    mounted() {
        this.loadItemList()
    },
    methods: {
        loadItemList() {
            if (this.loadFn) {
                this.loadFn(this.campaign.id).then(
                    result => {
                        this.itemList = result.data
                        //map old item
                        result.data.forEach(item => {
                            this.mapOldItem[item.id] = item
                        })
                        this.mapOldItem = this.$utils.cloneObject(this.mapOldItem)
                    },
                    this.$appService.handleRequestError(this.$t('actionFailed', {
                        action: this.$t('load'),
                        item: this.itemTranslate
                    }))
                )
            }
        },
        addItem() {
            this.itemList.push(JSON.parse(JSON.stringify(this.emptyItem)))
        },
        removeItem(index) {
            let config = this.itemList[index]
            if (config.id) {
                let i18n = {
                    action: this.$t('delete'),
                    item: this.itemTranslate
                }
                this.$appService.showLoading()
                this.deleteFn(this.campaign.id, config.id).then(
                    () => {
                        this.itemList.splice(index, 1)
                        this.$t('actionSuccessful', i18n)
                    },
                    this.$appService.handleRequestError(this.$t('actionFailed', i18n))
                ).finally(this.$appService.hideLoading)
            } else {
                this.itemList.splice(index, 1)
            }
        },
        saveForm() {
            let saveSuccessCount = 0
            let saveFailCount = 0
            let updateSuccessCount = 0
            let updateFailCount = 0
            let noChangeCount = 0
            let finallyFunction = () => {
                if (saveSuccessCount + saveFailCount + updateSuccessCount + updateFailCount + noChangeCount === this.itemList.length) {
                    let i18nSave = {
                        action: this.$f.tc('save'),
                        item: this.itemTranslate
                    }
                    if (saveSuccessCount > 0) {
                        this.$appService.toastSuccess(this.$f.tc('actionSuccessful', i18nSave) + ': ' + saveSuccessCount)
                    }
                    if (saveFailCount > 0) {
                        this.$appService.toastError(this.$f.tc('actionFailed', i18nSave) + ': ' + saveFailCount)
                    }
                    let i18nUpdate = {
                        action: this.$f.tc('update'),
                        item: this.itemTranslate
                    }
                    if (updateSuccessCount > 0) {
                        this.$appService.toastSuccess(this.$f.tc('actionSuccessful', i18nUpdate) + ': ' + updateSuccessCount)
                    }
                    if (updateFailCount > 0) {
                        this.$appService.toastError(this.$f.tc('actionFailed', i18nUpdate) + ': ' + updateFailCount)
                    }
                    this.loadItemList()
                }
            }
            for (let item of this.itemList) {
                if (item.id) {
                    // compare old item and new item
                    let oldItem = this.mapOldItem[item.id]
                    if (JSON.stringify(oldItem) === JSON.stringify(item)) {
                        noChangeCount++
                        finallyFunction()
                        continue
                    }
                    this.updateFn(this.campaign.id, item).then(
                        () => updateSuccessCount++,
                        () => updateFailCount++
                    ).finally(finallyFunction)
                } else {
                    this.saveFn(this.campaign.id, item).then(
                        () => saveSuccessCount++,
                        () => saveFailCount++
                    ).finally(finallyFunction)
                }
            }
        },
        submitValidForm() {
            this.saveForm()
        }
    }
}
</script>
